module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo13-6871b188da40d2fa16c8509318a7fd85.jpg";